//获取用户信息
export const getUserInfo = function (state) {
  return state.userInfo;
};

//获取loading状态
export const getLoading = function (state) {
  return state.loading;
};

//获取url参数
export const getUrlInfo = function (state) {
  return state.urlInfo;
};
//获取原文编辑状态
export const getSourceeditStatus = function (state) {
  return state.sourceedit;
};
//获取是否点击编辑原文的状态
export const getisSourceedit = function (state) {
  return state.isSourceedit;
};
//获取译文编辑状态
export const getTargeteditStatus = function (state) {
  return state.targetedit;
};
//获取检索编辑状态
export const getEleStatus = function (state) {
  return state.EleStatus;
};
//获取项目信息
export const getProjectInfo = function (state) {
  return state.projectInfo;
};

//获取文件信息
export const getFileInfo = function (state) {
  return state.fileInfo;
};
//获取任务进度
export const getTaskProgress = function (state) {
  return state.taskProgress;
};

//获取文件任务信息
export const getFileTaskInfo = function (state) {
  return state.fileTsakInfo;
};

//获取编辑器文件list
export const getTaskContentList = function (state) {
  return state.taskContentList;
};

//获取任务请求参数
export const getTaskContentListParams = function (state) {
  return state.taskContentListParams;
};

//获取QA列表
export const getQAList = function (state) {
  return state.QAList;
};

export const getFragmentQAList = function (state) {
  return state.fragmentQAInfo;
};

//获取定位信息
export const getPositionInfo = function (state) {
  return state.position;
};

//获取编辑器右键功能
export const getEditorRightShownInfo = function (state) {
  return state.editorRightShown;
};

//获取原文预览的数据
export const getFilePreviewContentInfo = function (state) {
  return state.filePreviewContent;
};
export const getPartIndex = function (state) {
  return state.wordPreview.partIndex;
}
export const getAppointPreview = function (state) {
  return state.setAppointPreview
}

//获取主题信息
export const getTheneList = function (state) {
  return state.theme;
};

export const getfontSettingList = function (state) {
  return state.fontSetting;
};

export const getfontSizeList = function (state) {
  return state.fontSize;
};

export const getscreenOptionsList = function (state) {
  return state.screenOptions;
};

export const getmessageStatus = function (state) {
  return state.messagestatus;
};
export const getmessageList = function (state) {
  return state.mymessageList;
};

export const getEditorModeInfo = function (state) {
  return state.editorMode;
};

export const getEditorFontSizeInfo = function (state) {
  return state.editorFontSize;
};

export const getThemeInfo = function (state) {
  return state.themeInfo;
};

export const getSearchInfo = function (state) {
  return state.searchInfo;
};

export const getCurrentSentenceIdInfo = function (state) {
  return state.currentSentenceId;
};

export const getModifyRecordInfo = function (state) {
  return state.modifyRecord;
};

//修改记录参数
export const getModifyRecordParamsInfo = function (state) {
  return state.modifyRecordParams;
};

//原译文预览参数
export const getPreviewParamsInfo = function (state) {
  return state.previewParams;
};

export const getQAStateInfo = function (state) {
  return state.QAState;
};

//获取片段的记忆库
export const getFragmentMemoryInfo = function (state) {
  return state.fragmentMemory;
};

//获取片段的术语库
export const getFragmentTermInfo = function (state) {
  return state.fragmentTerm;
};

//获取片段的批注信息
export const getFragmentRemarkInfo = function (state) {
  return state.currentRemarks;
};

//获取词典查询的内容
export const getTranslateDictionaryListInfo = function (state) {
  return state.translateDictionary;
};

//获取临时句子信息
export const getTempSentenceIdInfo = function (state) {
  return state.tempSentence;
};

//获取翻译建议ActiveName
export const getSuggestActiveNameInfo = function (state) {
  return state.suggestActiveName;
};

//获取编辑器底部ActiveName
export const getEditorBottomActiveNameInfo = function (state) {
  return state.editorBottomActiveName;
};

//获取撤销的数据
export const getRevokeInfo = function (state) {
  return state.revokeData;
};

//获取撤销
export const getRecoveryInfo = function (state) {
  return state.recoveryData;
};

//获取光标定位拆分的信息
export const getCursorPositionInfo = function (state) {
  return state.cursorPositionInfo;
};

//获取状态
export const getUpdataInfo = function (state) {
  return state.updata;
};

//获取译文的光标位置
export const getCursorPositionTargetInfo = function (state) {
  return state.cursorPositionTargetInfo;
};

//获取片段的更新类型
export const getUpdataFragmentTypeInfo = function (state) {
  return state.updataFragmentType;
};

//翻译建议的批注显示
export const getSuggestRemarksInfo = function (state) {
  return state.suggestRemarks;
};
//获取原译文修改值
export const getPreviewInfo = function (state) {
  return state.setPreviewInfo;
}
// 获取修改的句子相关数据
export const getSentCountInfo = function (state) {
  return state.setSentCountInfo
}
//获取词典清空状态
export const getthird = function (state) {
  return state.setthird;
}
// //获取编辑模式
// export const getComparisonMode = function (state) {
//   return state.comparisonMode;
// }
// //获取对照数据
// export const getComparisonList = function (state) {
//   return state.ComparisonList;
// }

//临时术语表 
export const temporaryTermList = (state) => {
  return state.temporaryTermList
}
// 导出选项
export const importOption = (state) => {
  return state.importOption
}
// 当前在表格或者上下对照
export const currentViewMode = (state) => {
  return state.currentViewMode
}
// 评价结果
export const evaluationResults = (state) => state.evaluationResults
// 机翻结果
export const fragmentSentenceMt = (state) => state.fragmentSentenceMt
//译文句子为空id 列表
export const getcountTargetIsnullIdList = (state) => {
  return state.countTargetIsnullIdList
}
//获取存储的编辑句子列表
export const getEditordataList = (state) => {
  return state.editordataList
}
